import Collapse from 'bootstrap/js/dist/collapse'

document.onclick = (event) => {
  const element = event.target as HTMLElement

  if (
    element.matches('.navbar-collapse *') ||
    element.matches('.navbar-toggle *')
  ) {
    return
  }

  const menu = document.querySelector<HTMLElement>('.navbar-collapse')
  if (menu) {
    const collapse = new Collapse(menu, { toggle: false })
    collapse.hide()
  }

  // Reset navigation indicator on close.
  const nav = document.getElementById('hamburger')
  if (nav && nav.classList.contains('open')) {
    document
      .querySelector<HTMLElement>('.navbar-toggle')
      ?.classList.remove('open')
  }
}

// Make navigation and profile menus mutually exclusive on mobile
const navMenu = document.getElementById('topnav-menu-content')
const profileMenu = document.getElementById('topnav-profile-content')

if (navMenu && profileMenu) {
  navMenu.addEventListener('show.bs.collapse', () => {
    const profileCollapse = new Collapse(profileMenu, { toggle: false })
    profileCollapse.hide()
  })

  profileMenu.addEventListener('show.bs.collapse', () => {
    const navCollapse = new Collapse(navMenu, { toggle: false })
    navCollapse.hide()
  })
}
